import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/rootState';
import { stripCustPrefix } from '../../../../../utils/CommonFunctions';
import { JobDetails } from '../../../types';

function TableThree({ data }: { data?: JobDetails }) {
  const { themePdfColor } = useSelector((state: RootState) => state.reportPdfSliceReducer);
  const { BorderColor, MainColor } = themePdfColor;
  const tickerData = data;

  return (
    <div style={{ paddingBottom: '20px', width: '95%', margin: '0 auto' }}>
      <table className="bordered-table w100">
        <div
          className="tableAfterThickBorderStyle"
          style={{
            backgroundColor: BorderColor,
          }}
        />
        <div
          className="tableBeforeThickBorderStyle"
          style={{
            backgroundColor: BorderColor,
          }}
        />
        <tr>
          <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>#</td>
          <td className="textCenter">
            <span className="boldText">Client</span>
            {` (${tickerData?.CustId ? stripCustPrefix(tickerData?.CustId) : ''})`}
          </td>
          <td className="textCenter">
            <span className="boldText">Site</span>
            {` (${tickerData?.SiteId || ''})`}
          </td>
        </tr>
        <tr>
          <td className=" tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>Name</td>
          <td className="textCenter">{tickerData?.Name}</td>
          <td className="textCenter">{tickerData?.SiteName}</td>
        </tr>
        <tr>
          <td className=" tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>Address</td>
          {/* <td className="textCenter">{`${tickerData?.Address}, ${tickerData?.OptionalAddress}`}</td>
          <td className="textCenter">{`${tickerData?.SiteAddress}, ${tickerData?.SiteOptionalAddress}`}</td> */}
          <td className="textCenter">
            {tickerData?.Address
              ? tickerData.Address + (tickerData.OptionalAddress ? ', ' : '')
              : ''}
            {tickerData?.OptionalAddress || ''}
          </td>
          <td className="textCenter">
            {tickerData?.SiteAddress
              ? tickerData.SiteAddress + (tickerData.SiteOptionalAddress ? ', ' : '')
              : ''}
            {tickerData?.SiteOptionalAddress || ''}
          </td>
        </tr>
        <tr>
          <td className=" tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>City, State, Zip, Country</td>
          {/* <td className="textCenter">{`${tickerData?.City}, ${tickerData?.State}, ${tickerData?.Zip}`}</td>
          <td className="textCenter">{`${tickerData?.SiteCity}, ${tickerData?.SiteCity}, ${tickerData?.SiteZip}`}</td> */}
          <td className="textCenter">
            {tickerData?.City
              ? tickerData.City + (tickerData.State || tickerData.Zip || tickerData.Country ? ', ' : '')
              : ''}
            {tickerData?.State
              ? tickerData.State + (tickerData.Zip || tickerData.Country ? ', ' : '')
              : ''}
            {tickerData?.Zip
              ? tickerData.Zip + (tickerData.Country ? ', ' : '')
              : ''}
            {tickerData?.Country || ''}
          </td>

          <td className="textCenter">
            {tickerData?.SiteCity
              ? tickerData.SiteCity + (tickerData.SiteState || tickerData.SiteZip || tickerData.SiteCountry ? ', ' : '')
              : ''}
            {tickerData?.SiteState
              ? tickerData.SiteState + (tickerData.SiteZip || tickerData.SiteCountry ? ', ' : '')
              : ''}
            {tickerData?.SiteZip
              ? tickerData.SiteZip + (tickerData.SiteCountry ? ', ' : '')
              : ''}
            {tickerData?.SiteCountry || ''}
          </td>

        </tr>
        <tr>
          <td className=" tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>Contact</td>
          <td className="textCenter">{tickerData?.Contact}</td>
          <td className="textCenter">{tickerData?.SiteContact}</td>
        </tr>
        <tr>
          <td className=" tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>Phone</td>
          <td className="textCenter">{tickerData?.Phone}</td>
          <td className="textCenter">{tickerData?.SitePhone}</td>
        </tr>
      </table>
    </div>
  );
}

export default TableThree;
